export const AUDIO_BALANCE_WAVEFORM = {
  Before: {
    left: [
      0.1, 0.1, 0.1, 0.1, 0.1, 0.1, 0.1, 0.1, 0.1, 0.11072761303010092, 0.13677667039961355,
      0.10825878387602736, 0.1355222103163499, 0.17789724071095825, 0.1984144276521593,
      0.1738957182373034, 0.231573356666262, 0.24776967542766773, 0.24498233037119346,
      0.26543590435607106, 0.28924149290102413, 0.20881833658926743, 0.20821807038510842,
      0.2826897993096843, 0.3324907865342348, 0.3524680211434349, 0.3175315248118442,
      0.32865312335401187, 0.29625561751091417, 0.39873340802047613, 0.4441065999362936,
      0.42812938193336464, 0.3884892427586314, 0.5051257376714661, 0.5093701510210911,
      0.4908470816054726, 0.44640392705690485, 0.5244100769739614, 0.5590269796247974,
      0.5141592850870939, 0.6219004408807257, 0.5508366163314137, 0.4939443000200276,
      0.5263372769587203, 0.6064622318629241, 0.630947011954104, 0.7202383037391066,
      0.7109152437643026, 0.7005162564562065, 0.5565504446743121, 0.5756651797993249,
      0.7081328187068456, 0.6868755237769898, 0.8305676234216662, 0.7834159589381258,
      0.7345837306823024, 0.7891846974837516, 0.7114740586213019, 0.9842295867683662,
      0.7540860639625037, 0.8516301786251621, 0.8264372799778297, 0.8800491988247621,
      0.832514296551139, 0.7418465890098689, 1, 0.8826267511860219, 0.9889108600559492,
      0.8382900024445368, 0.8023252752684483, 0.6658457165746585, 0.7444754558557851,
      0.8881914552512554, 0.7566076267988544, 0.9745306557250883, 0.8063049295678906,
      0.7650809488411996, 0.6229627264005193, 0.7693855408559983, 0.8985019236572164,
      0.7511320830853492, 0.9451212321154789, 0.7217472316065331, 0.7345462820636115,
      0.722369676312202, 0.7857334835386338, 0.796756036385591, 0.9161096994673151,
      0.9022719171689457, 0.674870118610549, 0.6844220266727156, 0.6208458453420866,
      0.8227396806168227, 0.8277819585414815, 0.8971288841980357, 0.8756594348362878,
      0.6610078161293894, 0.8694012032777216, 0.8421864778660844, 0.7257568418374971,
    ],
    right: [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
    ],
  },
  After: {
    left: [
      0.1, 0.1, 0.1, 0.1, 0.1, 0.1, 0.1, 0.1, 0.1, 0.10855662324419732, 0.13556304333519287,
      0.10915020238163137, 0.12798779733901158, 0.17705221646502953, 0.19798620202206663,
      0.17494881051770192, 0.22326001290341443, 0.24884501063769693, 0.23836686589945674,
      0.2665825947454569, 0.28467998206198053, 0.21637038143297835, 0.20429842222653963,
      0.27921853492527937, 0.32741105750564337, 0.3408681839012485, 0.32513777640861496,
      0.3239803439517615, 0.2937505270201996, 0.3967313701461356, 0.4325055250870831,
      0.43629749883420604, 0.37649641033873443, 0.5060383063661914, 0.5018911796473787,
      0.49429038314765106, 0.4375594231397625, 0.5244185317104839, 0.5468403168698365,
      0.5068269406483842, 0.6219256840284723, 0.5593660736497865, 0.4917256842542818,
      0.5264478261948727, 0.5881510785988587, 0.6368426355429765, 0.7055332961855141,
      0.7027947222794348, 0.7008346382783545, 0.5636574964323697, 0.5708289078943016,
      0.6988717253609031, 0.6861527735850876, 0.8195621893106114, 0.7732925552960898,
      0.7276994215673127, 0.7933406242634152, 0.6992668623279634, 0.9798814481320742,
      0.7574778604036864, 0.8360575918546935, 0.8295430028467595, 0.8555196098632193,
      0.8438739763996118, 0.7375050556370109, 1, 0.8680690358754671, 0.9874716759978724,
      0.8382893619707514, 0.7992884992957096, 0.6535693686957474, 0.7459508866442738,
      0.8847390173593416, 0.7502072745540178, 0.968195649398535, 0.8016431382352095,
      0.7624121005951094, 0.6186592660186013, 0.7564023532132593, 0.904606032209839,
      0.7449073168568, 0.9352630805286815, 0.7198837910221485, 0.7296288936702012,
      0.7213139062642915, 0.7794084233545835, 0.7916404812064163, 0.9093441621712026,
      0.8995323005283318, 0.6705050457453398, 0.6808476695833082, 0.6168454766217843,
      0.817883143683343, 0.8231303616113373, 0.89085572733104, 0.8708785601747593,
      0.6585628489730122, 0.865025657694525, 0.8340020829317358, 0.7182361349043607,
    ],
    right: [
      0.1, 0.1, 0.1, 0.1, 0.1, 0.1, 0.1, 0.1, 0.1, 0.10856020645858334, 0.13556330805362224,
      0.1091462837051516, 0.12799663854643928, 0.17705452055188656, 0.1979824526313514,
      0.1749546725768143, 0.223256381659688, 0.248848265528574, 0.23836084475129327,
      0.26658962338474534, 0.2846798367112153, 0.21637434566593172, 0.20430146883111036,
      0.2792192251918627, 0.3274197238397442, 0.34086547161032626, 0.3251455709446164,
      0.32396623414129977, 0.29374624111747555, 0.39672239851886826, 0.4325074240612473,
      0.43629720120838156, 0.3764959560578799, 0.5060415333065118, 0.5018924187857602,
      0.4942938013828382, 0.4375548254667354, 0.5244196301798094, 0.5468364760342772,
      0.5068170073839668, 0.6219325286667173, 0.5593635215726847, 0.4917368412042295,
      0.5264468426533113, 0.5881585035549353, 0.6368467203992685, 0.7055333961598657,
      0.7027993612827356, 0.7008342240636796, 0.5636681284721083, 0.5708245641003004,
      0.6988658887413849, 0.6861660699837231, 0.8195660208049463, 0.7732930946759398,
      0.7277095903660135, 0.7933411345996982, 0.6992749297911677, 0.9798873824867874,
      0.757494688812952, 0.8360640841106284, 0.8295489727240462, 0.8555190575682556,
      0.8438755843282747, 0.7375029675052478, 1, 0.8680772774159873, 0.9874734629998797,
      0.838292912229072, 0.7993018325072824, 0.6535683645470728, 0.7459573267289242,
      0.8847493049642486, 0.7502164411860838, 0.9682031281818124, 0.8016481165068358,
      0.7624181255052972, 0.6186561299047277, 0.756401952738473, 0.9046139522442161,
      0.744918673181284, 0.9352707745543416, 0.7198933078760914, 0.7296325511015284,
      0.7213174014049656, 0.779415266055759, 0.7916460276518628, 0.9093477982078538,
      0.8995351527950842, 0.6705095338118163, 0.6808448242811248, 0.6168451616783959,
      0.8178819235101632, 0.823127443600535, 0.8908565705068141, 0.8708814013262903,
      0.6585637134264647, 0.865022935383033, 0.8340069664095953, 0.7182462595234228,
    ],
  },
} as const;
